import { Component } from '@angular/core';

@Component({
  selector: 'di-service-unavailable',
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.scss'],
  standalone: false,
})
export class ServiceUnavailableComponent {}
